import { render, staticRenderFns } from "./storeManage.vue?vue&type=template&id=53c92cc2&scoped=true"
import script from "./storeManage.vue?vue&type=script&lang=js"
export * from "./storeManage.vue?vue&type=script&lang=js"
import style0 from "./storeManage.vue?vue&type=style&index=0&id=53c92cc2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c92cc2",
  null
  
)

export default component.exports